import styled from 'styled-components';


export const ChoiceDiv = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
`


export const RadioInput = styled.input`
    accent-color: #3A98B9;
    width: 25px;
    height: 25px;
`

